export default __webpack_public_path__ + "static/target@2x-1dbbf1829f5b7dd2900b9bc7a77fb6b8.png";